import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import deviceInfo from 'APP/packages/deviceInfo';

export const hasCamera = async (): Promise<boolean> => {
  const { hasCamera } = await deviceInfo.getMediaDevices();

  if (!hasCamera) {
    Tasks.app.showAlert(t('calls_no_camera_connected'));

    return false;
  }

  return true;
};
